import { render, staticRenderFns } from "./pos-VatReport.vue?vue&type=template&id=99040c5e"
import script from "./pos-VatReport.vue?vue&type=script&lang=js"
export * from "./pos-VatReport.vue?vue&type=script&lang=js"
import style0 from "./pos-VatReport.vue?vue&type=style&index=0&id=99040c5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports